import { Chakra } from "@airhelp/react-ui-components";
import Row from "./Row";
import type { TBodyProps } from "./TBody.d";

const { Tbody } = Chakra;

const TBody = ({ rows, getTableBodyProps, prepareRow }: TBodyProps) => (
  <Tbody {...getTableBodyProps()}>
    {rows.map((row, idx) => {
      prepareRow(row);
      return <Row key={row.id} content={row} isLast={rows.length - 1 === idx} />;
    })}
  </Tbody>
);

export default TBody;
